export enum FieldReceiptPartnerExcel {
    LadingCode = "ladingCode"
}